import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateInput.css';

export default function DateInput({ value, onChange, minDate, maxDate, ariaLabel, onFocus }) {
  const selected = value ? new Date(value + 'T00:00:00') : null;

  const handleChange = (date) => {
    if (!date) { onChange(''); return; }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    onChange(`${y}-${m}-${d}`);
  };

  return (
    <DatePicker
      selected={selected}
      onChange={handleChange}
      onFocus={onFocus}
      dateFormat="dd.MM.yyyy"
      placeholderText="TT.MM.JJJJ"
      className="input date-input"
      calendarClassName="dk-cal"
      popperClassName="dk-popper"
      popperPlacement="bottom-start"
      minDate={minDate ? new Date(minDate + 'T00:00:00') : undefined}
      maxDate={maxDate ? new Date(maxDate + 'T00:00:00') : undefined}
      aria-label={ariaLabel}
      autoComplete="off"
      isClearable
      showPopperArrow={false}
    />
  );
}
